import React from 'react';
import Extension from '@atlassian/jira-common-components-ecosystem-operations/src/index.tsx';
import { useBacklogSelector } from '../../../state/index.tsx';
import { operationsSelector } from '../../../state/selectors/extension/index.tsx';

type Props = {
	isTabNavigation?: boolean;
};

const Extensions = ({ isTabNavigation = false }: Props) => {
	const operations = useBacklogSelector(operationsSelector);
	return <Extension operations={operations} isTabNavigation={isTabNavigation} />;
};

export default Extensions;
